<template>
  <div class="p-6">
    <vs-alert color="danger" active="true" class="mb-4">
      ⚠️ Outil de correction TVA bois de feu — BROUILLONS. Chaque bouton « Envoyer » transmet
      RÉELLEMENT le document à l'ANAF (mode <b>{{ mode.toUpperCase() }}</b>). En PROD, c'est
      irréversible. À faire valider par le comptable. Numéros <code>_1</code>/<code>_2</code> = placeholders.
    </vs-alert>

    <div class="flex items-center mb-6">
      <span class="mr-3">Mode d'envoi :</span>
      <vs-switch v-model="prodMode" color="danger">
        <span slot="on">PROD</span>
        <span slot="off">TEST</span>
      </vs-switch>
      <span class="ml-4 font-bold" :class="prodMode ? 'text-danger' : 'text-success'">
        {{ prodMode ? 'PRODUCTION (envoi réel ANAF)' : 'TEST (bac à sable ANAF)' }}
      </span>
    </div>

    <div v-for="grp in grouped" :key="grp.origin" class="mb-6" style="border:1px solid #ddd;border-radius:6px;padding:14px">
      <h4 class="mb-3">Facture d'origine {{ grp.origin }} — {{ grp.client }}</h4>

      <div v-for="it in grp.items" :key="it.number" class="mb-4" style="padding-left:10px;border-left:4px solid #ccc"
        :style="{ borderLeftColor: it.kind.indexOf('Note') !== -1 ? '#f0a020' : '#2c6ecb' }">
        <div class="flex items-center flex-wrap">
          <b class="mr-3">{{ it.kind }}</b>
          <vs-chip color="dark">{{ it.number }}</vs-chip>
          <vs-button size="small" type="border" class="ml-3" @click="$set(it, '_show', !it._show)">Voir XML</vs-button>
          <vs-button size="small" class="ml-3" :color="prodMode ? 'danger' : 'primary'"
            :disabled="!!sending[it.number]" @click="confirmSend(it)">
            {{ sending[it.number] ? 'Envoi…' : 'Envoyer (' + mode.toUpperCase() + ')' }}
          </vs-button>
          <vs-button v-if="results[it.number] && results[it.number].index_incarcare"
            size="small" type="border" class="ml-3" @click="checkStatus(it)">Vérifier statut</vs-button>
        </div>

        <pre v-if="it._show"
          style="max-height:260px;overflow:auto;background:#f7f7f7;padding:8px;font-size:11px;margin-top:6px">{{ it.xml }}</pre>

        <div v-if="results[it.number]" class="mt-2" style="font-size:13px">
          <span v-if="results[it.number].error" class="text-danger">Erreur : {{ results[it.number].error }}</span>
          <template v-else>
            <span>id_incarcare : <b>{{ results[it.number].index_incarcare || '—' }}</b></span>
            <span class="ml-4">id_descarcare : <b>{{ results[it.number].id_descarcare || '(en attente — cliquer « Vérifier statut »)' }}</b></span>
            <span class="ml-4">état : <b>{{ results[it.number].status || '—' }}</b></span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firewoodXml from "./firewoodXml";

export default {
  data() {
    return {
      prodMode: false,
      items: firewoodXml.map((x) => ({ ...x, _show: false })),
      sending: {},
      results: {},
    };
  },
  computed: {
    mode() {
      return this.prodMode ? "prod" : "test";
    },
    grouped() {
      const map = {};
      this.items.forEach((it) => {
        if (!map[it.origin]) map[it.origin] = { origin: it.origin, client: it.client, items: [] };
        map[it.origin].items.push(it);
      });
      return Object.values(map);
    },
  },
  methods: {
    confirmSend(it) {
      const label = this.prodMode ? "PRODUCTION (irréversible, envoi réel ANAF)" : "TEST";
      this.$vs.dialog({
        type: "confirm",
        color: this.prodMode ? "danger" : "primary",
        title: "Confirmer l'envoi",
        text: `Envoyer « ${it.kind} » (${it.number}) à l'ANAF en mode ${label} ?`,
        accept: () => this.send(it),
      });
    },
    send(it) {
      this.$set(this.sending, it.number, true);
      this.$store
        .dispatch("BankList/sendRawXmlEfactura", { xmldata: it.xml, mode: this.mode })
        .then((response) => {
          const d = response.data || {};
          this.$set(this.results, it.number, {
            index_incarcare: d.index_incarcare,
            id_descarcare: null,
            status: d.errors ? "erreur ANAF" : "envoyé",
            error: d.errors ? JSON.stringify(d.errors) : null,
          });
          this.$vs.notify({ color: d.errors ? "warning" : "success", title: "ANAF", text: d.errors ? "Réponse avec erreurs — voir détail" : `Envoyé (id_incarcare ${d.index_incarcare})` });
        })
        .catch((error) => {
          const msg = (error.response && (error.response.data.message || JSON.stringify(error.response.data))) || error.message;
          this.$set(this.results, it.number, { error: msg });
          this.$vs.notify({ color: "danger", title: "Échec envoi ANAF", text: msg });
        })
        .finally(() => this.$set(this.sending, it.number, false));
    },
    checkStatus(it) {
      const r = this.results[it.number];
      if (!r || !r.index_incarcare) return;
      this.$store
        .dispatch("BankList/getRawXmlStatusEfactura", { mode: this.mode, id: r.index_incarcare })
        .then((response) => {
          const d = response.data || {};
          this.$set(this.results, it.number, { ...r, status: d.status, id_descarcare: d.id_descarcare });
        })
        .catch((error) => {
          const msg = (error.response && error.response.data && (error.response.data.message || JSON.stringify(error.response.data))) || error.message;
          this.$vs.notify({ color: "danger", title: "Statut ANAF", text: msg });
        });
    },
  },
};
</script>
